export const TABLE_KEYS = {
  RETURNS: 'returns',
  ORDERS: 'orders',
  ASSISTANCE_REQUEST: 'assistance_request',
  CLIENTS: 'clients',
  USERS: 'users',
  PRODUCTS: 'products',
  BROKENS: 'brokens'
};
